import React, { FC } from 'react';
import { useRoute } from '@react-navigation/native';

import DashboardDrilldownWrapper from './components/DashboardDrilldownWrapper';
import DashboardDrilldownTabbedBody from './components/DashboardDrilldownTabbedBody';
import DashboardDrilldownTabs from './components/DashboardDrilldownTabbedBody/components/DashboardDrilldownTabs';
import { useManageDashboardDrilldownTabbedBody } from './components/DashboardDrilldownTabbedBody/hooks/useManageDashboardDrilldownTabbedBody';
import { DashboardDrilldownScope, type DashboardDrilldownTabbedRouteParams } from '@v2/pages/dashboard/common/types/drilldown';

const DashboardDrilldownMachineScreen: FC = () => {
  const route = useRoute<any>();
  const params = (route.params ?? {}) as Partial<DashboardDrilldownTabbedRouteParams>;
  const drilldownId = params.drilldownId;

  const drilldownType = DashboardDrilldownScope.Machine;
  const { tab, childScope, drilldownFilter, onSelectTab } = useManageDashboardDrilldownTabbedBody({
    drilldownType,
    drilldownId: drilldownId ?? '',
  });

  if (!drilldownId) return null;

  return (
    <DashboardDrilldownWrapper
      scope={drilldownType}
      entityName={params.drilldownName}
      // headerRight={<DashboardDrilldownTabs drilldownType={drilldownType} tab={tab} onSelectTab={onSelectTab} />}
    >
      <DashboardDrilldownTabbedBody tab={tab} childScope={childScope} drilldownFilter={drilldownFilter} />
    </DashboardDrilldownWrapper>
  );
};

export default DashboardDrilldownMachineScreen;
